import React, { useEffect } from "react";
import VendorTransaction from "./VendorTransaction";
import PaymentTable from "./PaymentTable";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptedClusterByVendor,
  mainDashboardOfPayment,
} from "../../../redux/slices/vendorPaymentSlice";

const VendorMoney = () => {
  const dispatch = useDispatch();
  const { vendorId } = useSelector((state) => state.vendorAuth);
  useEffect(() => {
    if (vendorId) {
      dispatch(acceptedClusterByVendor(vendorId));
      dispatch(mainDashboardOfPayment(vendorId));
    }
  }, [vendorId, dispatch]);
  return (
    <div className="bg-gray-50 h-[90vh] flex flex-col">
      <VendorTransaction />
      <div className="flex-1 ">
        <PaymentTable />
      </div>
    </div>
  );
};

export default VendorMoney;
